<div id="team-insights-component">
  <div *ngIf="teamHasType(); else lockedView">
    <div class="container unlocked">
      <div class="intro-title">Understand your team</div>
      <div class="intro-copy">
        Uncover how the preferences of you and your team members play into your everyday team dynamics.<br />
        Get clear and practical suggestions on how to improve these dynamics within your team.
      </div>

      <div class="row justify-content-center">
        <div class="col-md-12 col-lg-6">
          <div class="unlocked-card">
            <div class="card-icon">
              <img src="assets/images/three-people-standing.svg" />
            </div>
            <div class="card-copy">
              Problem Solving Styles in Teams
              <div class="card-sub-copy">See how your problem solving style compares to your team's problem solving style.</div>
              <a class="learn-more-link" [routerLink]="['/team/problem-solving']">Learn more »</a>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-lg-6">
          <div class="unlocked-card">
            <div class="card-icon">
              <img src="assets/images/two-people-sitting-at-table.svg" />
            </div>
            <div class="card-copy">
              Communication Styles in Teams
              <div class="card-sub-copy">See how your problem solving style compares to your team's problem solving style.</div>
              <a class="learn-more-link" [routerLink]="['/team/communication-styles']">Learn more »</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template #lockedView>
    <div class="container-fluid locked">
      <div class="row justify-content-center">
        <div class="col-md-12 col-lg-6 cards">
          <div class="locked-card card1">
            <div class="card-icon">
              <img src="assets/images/two-people-sitting-at-table-gray.svg" />
            </div>
            <div class="card-copy">Communication Styles in Teams</div>
          </div>
          <div class="locked-card card2">
            <div class="card-icon">
              <img src="assets/images/three-people-standing-gray.svg" />
            </div>
            <div class="card-copy">Problem Solving Styles in Teams</div>
          </div>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-md-12 col-lg-6 locked-text-section">
          <div class="lock-container">
            <img src="assets/images/lock.svg" class="lock-icon" />
          </div>
          <div class="content-container">
            <div class="intro-title">Unlock your team’s potential</div>
            <div class="intro-copy">
              Get access to valuable insights into you and your team once all your team members have completed their assessments.
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</div>
